import { Layout } from "../UI/Layout";
import { useSearchParams } from "react-router-dom";
import { useEventOrderById } from "./useEventOrderById";
import { FullScreenLoading } from "../UI/FullScreenLoading";
import { OrderSummary } from "./OrderSummary";
import { useTranslation } from "react-i18next";
import { useAuthCtx } from "../Auth/useAuthCtx";
import { OrderChannels, useOrderChannel } from "./useOrderChannel";
import { OrderQrCodeCard } from "./OrderQrCodeCard";
import { useEventInfoById } from "../Event/useEventInfoById";
import { canShowEventMap } from "../Event/canShowEventMap";
import { EventMap } from "../Event/EventMap";
import { Header } from "../UI/Header";
import { Footer } from "../UI/Footer";
import { AppStoresDownload } from "./AppStoresDownload";

type Props = {
  orderId: string;
};

function ThankyouInnerComponent(props: Props) {
  const { order, loading } = useEventOrderById(props.orderId);
  const { event: eventInfo, loading: loadingEventInfo } = useEventInfoById(
    order?.eventId
  );
  const { user } = useAuthCtx();
  const channel = useOrderChannel();
  const { t } = useTranslation();

  if (loading || loadingEventInfo) return <FullScreenLoading />;

  if (!order || !user) return null; //TODO 404

  const imgSrc =
    order.eventGallery.length > 0
      ? order.eventGallery[0].src
      : "/fallback-thankyou.jpg";

  return (
    <Layout>
      <Header />
      <div className={"p-4"}>
        <h1 className={"text-gray-900 font-bold text-2xl"}>
          {t("thankyou.title")}
        </h1>
        <p className={"text-gray-600 mb-4"}>
          {t("thankyou.youCanCloseThisPage")}
        </p>
        <div
          style={{
            backgroundImage: `url(${imgSrc})`,
          }}
          className={
            "w-full rounded-lg mb-4 bg-cover h-40 bg-no-repeat bg-center"
          }
        />
        <OrderSummary order={order} />
        {channel === OrderChannels.Web ? (
          <div className={"mt-4"}>
            <OrderQrCodeCard order={order} />
          </div>
        ) : null}
        {channel === OrderChannels.Web &&
        eventInfo &&
        canShowEventMap(eventInfo) ? (
          <div className={"mt-4"}>
            <EventMap eventInfo={eventInfo} />
          </div>
        ) : null}
        {channel === OrderChannels.Web ? (
          <div className={"mt-4"}>
            <AppStoresDownload />
          </div>
        ) : null}
      </div>
      <Footer />
    </Layout>
  );
}
export function ThankyouScreen() {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("oid");

  if (!orderId) return null; //TODO 404
  return <ThankyouInnerComponent orderId={orderId} />;
}
